import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService, UserDto, UserDtoPartialUpdate } from 'swagger-client';

import { PartialUserWithId, User } from '../models';

/*
 * This API service contains all unauthenticated call to backend.
 * To add authenticated calls, go in API service of the auth module.
 */
@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private apiAuthService = inject(AuthService);

  public me(): Observable<User> {
    return this.apiAuthService.authCurrentList().pipe(
      map((user) => this.userDtoToUser(user)),
      catchError((err) => throwError(() => err)),
    );
  }

  public logout(): Observable<void> {
    return this.apiAuthService.authLogoutCreate();
  }

  public userDtoToUser(user: UserDto): User {
    if (user.id === undefined) {
      throw new Error('User is undefined');
    }
    const { ...otherProperties } = user;
    return {
      ...otherProperties,
    };
  }
  public userToUserDto(user: User): UserDto {
    const { ...otherProperties } = user;
    return {
      ...otherProperties,
    };
  }

  public userToPartialUserDto(user: PartialUserWithId): UserDtoPartialUpdate {
    const { ...otherProperties } = user;
    return {
      ...otherProperties,
    };
  }
}
